import domReady from '@wordpress/dom-ready';
import { render, createRoot, useState } from '@wordpress/element';
import { comparisonList } from './data';
import dokanLogo from './images/dokan-logo.png';
import wcfm from './images/wcfm-logo.png';
import wcVendors from './images/wc-vendors-logo.png';
import wcMarketplace from './images/wc-marketplace.png';
import yith from './images/yith-logo.png';
import wcProductVendors from './images/wc-product-vendors.png';

const selectOptionValue = {
	all: 'all',
	'wcfm-marketplace': 'has-wcfm-marketplace',
	'wc-vendor': 'has-wc-vendor',
	'wc-marketplace': 'has-wc-marketplace',
	'yith-inspiration': 'has-yith-inspiration',
	'wc-product-vendors': 'has-wc-product-vendors',
};

const App = ( { attributes } ) => {
	const { startingPrice, activeInstallations, wpRating, trustPilotRating } =
		attributes;
	const [ activeProduct, setActiveProduct ] = useState( 'all' );

	const handleChange = ( e ) => {
		setActiveProduct( e.target.value );
	};

	return (
		<div
			id="dokan-comparison"
			className="comparison-section dokan-comparison-section"
		>
			<div
				className={ `container ${ selectOptionValue[ activeProduct ] }` }
			>
				<div className="comparison-header">
					<form action="#">
						<label htmlFor="comparisonList">
							Compare Dokan Multivendor with
						</label>
						<div className="custom-select-wrapper">
							<select
								id="comparisonList"
								className="compare-list dokan"
								onChange={ handleChange }
							>
								<option value="all">All Comparison</option>
								<option value="wcfm-marketplace">
									WCFM Marketplace
								</option>
								<option value="wc-vendor">WC Vendors</option>
								<option value="wc-marketplace">
									MultivendorX
								</option>
								<option value="yith-inspiration">
									YITH Multivendor
								</option>
								<option value="wc-product-vendors">
									WC Product Vendors
								</option>
							</select>
						</div>
					</form>
				</div>

				<div className="comparison-list">
					<ul>
						<li className="comparison-header">
							<div className="feature-name">
								<h3>Features</h3>
							</div>
							<div className="dokan dokan-pro">
								<img width="91" src={ dokanLogo } alt="dokan" />
							</div>

							<div className="wcfm-marketplace">
								<img
									width="142"
									src={ wcfm }
									alt="wcfm-marketplace"
								/>
							</div>

							<div className="wc-vendors">
								<img
									width="131"
									src={ wcVendors }
									alt="wc-vendor"
								/>
							</div>

							<div className="wc-marketplace">
								<img
									width="106"
									src={ wcMarketplace }
									alt="wc-market"
								/>
							</div>

							<div className="yith-multivendor">
								<img width="65" src={ yith } alt="yith-logo" />
							</div>

							<div className="wc-product-vendors">
								<img
									width="73"
									src={ wcProductVendors }
									alt="wc-product-vendor"
								/>
							</div>
						</li>

						<li>
							<div className="feature-name">Starting Price</div>
							<div
								className="dokan dokan-pro"
								dangerouslySetInnerHTML={ {
									__html: startingPrice?.dokan,
								} }
							></div>
							<div
								className="wcfm-marketplace"
								dangerouslySetInnerHTML={ {
									__html: startingPrice?.wcfm,
								} }
							></div>
							<div
								className="wc-vendors"
								dangerouslySetInnerHTML={ {
									__html: startingPrice?.wcVendors,
								} }
							></div>
							<div
								className="wc-marketplace"
								dangerouslySetInnerHTML={ {
									__html: startingPrice?.multivendorX,
								} }
							></div>
							<div
								className="yith-multivendor"
								dangerouslySetInnerHTML={ {
									__html: startingPrice?.yith,
								} }
							></div>
							<div
								className="wc-product-vendors"
								dangerouslySetInnerHTML={ {
									__html: startingPrice?.wcProductVendors,
								} }
							></div>
						</li>
						<li>
							<div className="feature-name">
								Active Installations
							</div>
							<div
								className="dokan dokan-pro"
								dangerouslySetInnerHTML={ {
									__html: activeInstallations?.dokan,
								} }
							></div>
							<div
								className="wcfm-marketplace"
								dangerouslySetInnerHTML={ {
									__html: activeInstallations?.wcfm,
								} }
							></div>
							<div
								className="wc-vendors"
								dangerouslySetInnerHTML={ {
									__html: activeInstallations?.wcVendors,
								} }
							></div>
							<div
								className="wc-marketplace"
								dangerouslySetInnerHTML={ {
									__html: activeInstallations?.multivendorX,
								} }
							></div>
							<div
								className="yith-multivendor"
								dangerouslySetInnerHTML={ {
									__html: activeInstallations?.yith,
								} }
							></div>
							<div
								className="wc-product-vendors"
								dangerouslySetInnerHTML={ {
									__html: activeInstallations?.wcProductVendors,
								} }
							></div>
						</li>
						<li>
							<div className="feature-name">
								WordPress.org Rating
							</div>
							<div
								className="dokan dokan-pro"
								dangerouslySetInnerHTML={ {
									__html: wpRating?.dokan,
								} }
							></div>
							<div
								className="wcfm-marketplace"
								dangerouslySetInnerHTML={ {
									__html: wpRating?.wcfm,
								} }
							></div>
							<div
								className="wc-vendors"
								dangerouslySetInnerHTML={ {
									__html: wpRating?.wcVendors,
								} }
							></div>
							<div
								className="wc-marketplace"
								dangerouslySetInnerHTML={ {
									__html: wpRating?.multivendorX,
								} }
							></div>
							<div
								className="yith-multivendor"
								dangerouslySetInnerHTML={ {
									__html: wpRating?.yith,
								} }
							></div>
							<div
								className="wc-product-vendors"
								dangerouslySetInnerHTML={ {
									__html: wpRating?.wcProductVendors,
								} }
							></div>
						</li>
						<li>
							<div className="feature-name">Trust Pilot</div>
							<div
								className="dokan dokan-pro"
								dangerouslySetInnerHTML={ {
									__html: trustPilotRating?.dokan,
								} }
							></div>
							<div
								className="wcfm-marketplace"
								dangerouslySetInnerHTML={ {
									__html: trustPilotRating?.wcfm,
								} }
							></div>
							<div
								className="wc-vendors"
								dangerouslySetInnerHTML={ {
									__html: trustPilotRating?.wcVendors,
								} }
							></div>
							<div
								className="wc-marketplace"
								dangerouslySetInnerHTML={ {
									__html: trustPilotRating?.multivendorX,
								} }
							></div>
							<div
								className="yith-multivendor"
								dangerouslySetInnerHTML={ {
									__html: trustPilotRating?.yith,
								} }
							></div>
							<div
								className="wc-product-vendors"
								dangerouslySetInnerHTML={ {
									__html: trustPilotRating?.wcProductVendors,
								} }
							></div>
						</li>

						{ comparisonList.map( ( item ) => (
							<li key={ item.featureName }>
								<div
									className="feature-name"
									dangerouslySetInnerHTML={ {
										__html: item.featureName,
									} }
								></div>

								<div
									className="dokan dokan-pro"
									dangerouslySetInnerHTML={ {
										__html: item.featureItems.dokan.key,
									} }
								></div>
								<div
									className="wcfm-marketplace"
									dangerouslySetInnerHTML={ {
										__html: item.featureItems
											.wcfmMarketplace.key,
									} }
								></div>
								<div
									className="wc-vendors"
									dangerouslySetInnerHTML={ {
										__html: item.featureItems.wcVendor.key,
									} }
								></div>
								<div
									className="wc-marketplace"
									dangerouslySetInnerHTML={ {
										__html: item.featureItems.wcMarketplace
											.key,
									} }
								></div>
								<div
									className="yith-multivendor"
									dangerouslySetInnerHTML={ {
										__html: item.featureItems
											.yithInspiration.key,
									} }
								></div>
								<div
									className="wc-product-vendors"
									dangerouslySetInnerHTML={ {
										__html: item.featureItems
											.wcProductVendors.key,
									} }
								></div>
							</li>
						) ) }
					</ul>
				</div>
			</div>
		</div>
	);
};

domReady( () => {
	const mountWrap = document.getElementById( 'do-block-comparison-table' );
	const blockAttributes = JSON.parse(
		mountWrap.getAttribute( 'data-block-attributes' )
	);

	if ( createRoot ) {
		createRoot( mountWrap ).render(
			<App attributes={ blockAttributes } />
		);
	} else {
		render( <App attributes={ blockAttributes } />, mountWrap );
	}
} );
